/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_BInputs */



/**
* | output |
* | --- |
* | "Event B" |
*
* @param {Event_BInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_b = /** @type {((inputs?: Event_BInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_BInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Événement B")
	if (locale === "de") return /** @type {LocalizedString} */ ("Veranstaltung B")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento B")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Событие B")
	if (locale === "es") return /** @type {LocalizedString} */ ("Evento B")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件 B")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベントB")
	if (locale === "hi") return /** @type {LocalizedString} */ ("घटना बी")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento B")
	return /** @type {LocalizedString} */ ("Event B")
});